export default [
    {
        path: '/evarecorddetails',
        name: 'evarecorddetails',
        component: () => import('@/views/eva/evacompile/evaparticulars/evarecorddetails.vue'),
    },
    {
        path: '/equipmentscore',
        name: 'equipmentscore',
        component: () => import('@/views/eva/evacompile/evaparticulars/equipmentscore.vue'),
    },
    {
        path: '/evarecorddetailsOnly',
        name: 'evarecorddetailsOnly',
        component: () => import('@/views/eva/evacompile/evaparticulars/evarecorddetailsOnly.vue'),
    },
    {
        path: '/evaindexOnly',
        name: 'evaindexOnly',
        component: () => import('@/views/eva/evacompile/PageControlOnly/indexOnly.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/evaHome',
        name: 'EvaHome',
        component: () => import('@/views/eva/evaHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/evacompile',
        name: 'evacompile',
        component: () => import('@/views/eva/evacompile/index.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/evalssue',
        name: 'evalssue',
        component: () => import('@/views/eva/evalssue/index.vue'),
    },
    // {
    //     path: '/patroldistribute',
    //     name: 'patroldistribute',
    //     component: () => import('@/views/evaluateServe/evaluateIssue/distribute.vue'),
    // },
    // {
    //     path: '/patroldetailsHome',
    //     name: 'patroldetailsHome',
    //     component: () => import('@/views/evaluateServe/evaluateDetails/detailsHome.vue'),
    // },
    //人员操作详情
    {
        path: '/evapersonnelOperation',
        name: 'evapersonnelOperation',
        component: () => import('@/views/eva/scoringDetails/personnelOperation.vue'),
    },
    //发布评论
    {
        path: '/evapostcomments',
        name: 'evapostcomments',
        component: () => import('@/views/eva/publish/postcomments.vue'),
    },
    //下载
    {
        path: '/evadownload',
        name: 'evadownload',
        component: () => import('@/views/eva/common/download.vue'),
    },
    //生成
    {
        path: '/evacreate',
        name: 'evacreate',
        component: () => import('@/views/eva/common/create.vue'),
    },
    //数据来源source
    {
        path: '/evasource',
        name: 'evasource',
        component: () => import('@/views/eva/common/source.vue'),
    },
    //选择参与设备
    {
        path: '/evadevices',
        name: 'evadevices',
        component: () => import('@/views/eva/common/devices.vue'),
    }
]
